import { mergeStyles } from "@fluentui/react/lib/Styling";
import { designTokens } from "./shared.styles";
export const reviewSubmitTabStyles = {
    incidentTilesContainer: mergeStyles({
        display: "flex",
        flexDirection: "column",
        gap: designTokens.spacing.sm,
        marginTop: designTokens.spacing.sm,
    }),
    incidentTile: mergeStyles({
        width: "100%",
        maxWidth: "400px",
        height: "auto",
        padding: designTokens.spacing.md,
        border: `1px solid ${designTokens.colors.borderLight}`,
        borderRadius: designTokens.borderRadius,
        backgroundColor: designTokens.colors.white,
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        transition: designTokens.transitions.default,
        ":hover": {
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
        },
    }),
    tileHeader: mergeStyles({
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        paddingBottom: "0",
        borderBottom: "none",
    }),
    tileContent: mergeStyles({
        flex: 1,
        overflow: "auto",
    }),
    tileField: mergeStyles({
        marginBottom: designTokens.spacing.sm,
    }),
    tileFieldLabel: mergeStyles({
        fontSize: "11px",
        fontWeight: 600,
        color: "#666666",
        textTransform: "uppercase",
        marginBottom: "2px",
    }),
    tileFieldValue: mergeStyles({
        fontSize: "13px",
        color: designTokens.colors.text,
        wordBreak: "break-word",
        lineHeight: 1.3,
    }),
};
